import { Map } from 'immutable'
import { normalize, schema } from 'normalizr'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import {
  GET_COLLABORATORS,
  GET_INVITES_SENT,
  GET_INVITES_RECEIVED,
  SEND_COLLAB_INVITE,
  ACCEPT_COLLAB_INVITE,
  IGNORE_COLLAB_INVITE,
  DELETE_COLLAB_INVITE,
  REMIND_COLLAB_INVITE,
  DELETE_COLLAB,
  CREATE_COLLAB_NOTE,
  GET_NOTES_RECEIVED,
  GET_NOTES_SENT,
  UPDATE_COLLAB_NOTE,
  DELETE_COLLAB_NOTE,
  ARCHIVE_COLLAB_NOTE,
  READ_COLLAB_NOTE,
  CLOSE_COLLAB_NOTE,
} from './actions'

export const INITIAL_STATE = new Map({
  collaborators: new Map(),
  notesSent: new Map(),
  notesReceived: new Map(),
  invitesSent: new Map(),
  invitesReceived: new Map(),
})

export const collabSchema = new schema.Entity('collaboration', {}, { idAttribute: '_id' })
export const collabNoteSchema = new schema.Entity('collaborationNote', {}, { idAttribute: '_id' })
export const collabInviteSchema = new schema.Entity(
  'collaborationInvite',
  {},
  { idAttribute: '_id' }
)

export const collab = createReducer(INITIAL_STATE, {
  [GET_COLLABORATORS.FULFILLED]: (state, { payload }) =>
    state.set('collaborators', new Map(normalize(payload, [collabSchema]).entities.collaboration)),

  [GET_INVITES_SENT.FULFILLED]: (state, { payload }) =>
    state.set(
      'invitesSent',
      new Map(normalize(payload, [collabInviteSchema]).entities.collaborationInvite)
    ),

  [GET_INVITES_RECEIVED.FULFILLED]: (state, { payload }) =>
    state.set(
      'invitesReceived',
      new Map(normalize(payload, [collabInviteSchema]).entities.collaborationInvite)
    ),

  [SEND_COLLAB_INVITE.FULFILLED]: (state, { payload }) =>
    state.set(
      'invitesSent',
      new Map(normalize(payload, [collabInviteSchema]).entities.collaborationInvite)
    ),

  [IGNORE_COLLAB_INVITE.FULFILLED]: (state, { payload }) =>
    state.set(
      'invitesSent',
      new Map(normalize(payload, [collabInviteSchema]).entities.collaborationInvite)
    ),

  [ACCEPT_COLLAB_INVITE.FULFILLED]: (state, { payload }) => {
    const updatedMap = state.get('invitesReceived').delete(payload.inviteId)
    return state.set('invitesReceived', updatedMap)
  },

  [DELETE_COLLAB_INVITE.FULFILLED]: (state, { payload }) =>
    state.set(
      'invitesSent',
      new Map(normalize(payload, [collabInviteSchema]).entities.collaborationInvite)
    ),

  [REMIND_COLLAB_INVITE.FULFILLED]: state => state,

  [DELETE_COLLAB.FULFILLED]: (state, { payload }) =>
    state.set('collaborators', new Map(normalize(payload, [collabSchema]).entities.collaboration)),

  [CREATE_COLLAB_NOTE.FULFILLED]: (state, { payload }) =>
    state.set(
      'notesSent',
      new Map(normalize(payload, [collabNoteSchema]).entities.collaborationNote)
    ),

  [GET_NOTES_RECEIVED.FULFILLED]: (state, { payload }) =>
    state.set(
      'notesReceived',
      new Map(normalize(payload, [collabNoteSchema]).entities.collaborationNote)
    ),

  [GET_NOTES_SENT.FULFILLED]: (state, { payload }) =>
    state.set(
      'notesSent',
      new Map(normalize(payload, [collabNoteSchema]).entities.collaborationNote)
    ),

  [UPDATE_COLLAB_NOTE.FULFILLED]: (state, { payload }) =>
    state.set(
      'notesSent',
      new Map(normalize(payload, [collabNoteSchema]).entities.collaborationNote)
    ),

  [DELETE_COLLAB_NOTE.FULFILLED]: (state, { payload }) =>
    state.set(
      'notesSent',
      new Map(normalize(payload, [collabNoteSchema]).entities.collaborationNote)
    ),

  [ARCHIVE_COLLAB_NOTE.FULFILLED]: (state, { payload }) =>
    state.set(
      'notesSent',
      new Map(normalize(payload, [collabNoteSchema]).entities.collaborationNote)
    ),

  [READ_COLLAB_NOTE.FULFILLED]: (state, { payload }) =>
    state.set(
      'notesReceived',
      new Map(normalize(payload, [collabNoteSchema]).entities.collaborationNote)
    ),

  [CLOSE_COLLAB_NOTE.FULFILLED]: (state, { payload }) =>
    state.set(
      'notesReceived',
      new Map(normalize(payload, [collabNoteSchema]).entities.collaborationNote)
    ),

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/collaboration/reducers.js